import React, { useState } from 'react';
import classNames from 'classnames';

// import i18n from '../../i18n';
// import PropTypes from 'prop-types';
import SwiperCore, { A11y, Navigation, Pagination, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import Button from '../Button';
import styles from './DistrictSlideCard.module.scss';
import Picture from '../Picture';
import 'swiper/swiper-bundle.css';
import ButtonRound from '../ButtonRound';
import i18n from '../../i18n';
import Image from 'next/image';

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

const DistrictSlideCard = ({ id, image, label, title, text, link, tags }) => {
    return (
        <div className={styles['DistrictSlideCard']}>
            <div className={styles['DistrictSlideCard__CardContainer']} id={id}>
                <div className={styles['DistrictSlideCard__ImageContainer']}>
                    {image.renditions && (
                        <figure>
                            <img
                                className={
                                    styles['DistrictSlideCard__DesktopImage']
                                }
                                sizes="100vw"
                                srcSet={`${image.renditions.xlarge.src} 1646w,
                                 ${image.renditions.large.src} 1200w,
                                ${image.renditions.medium.src} 600w`}
                                src={image.renditions.small.src}
                                alt={`${image.alt}`}
                            />
                        </figure>
                    )}
                </div>
                <div className={styles['DistrictSlideCard__TextContainer']}>
                    <div
                        className={
                            styles['DistrictSlideCard__MobileTextWrapper']
                        }>
                        <div
                            className={
                                styles[
                                    'DistrictSlideCard__MobileImageContainer'
                                ]
                            }>
                            {image.renditions && (
                                <figure>
                                    <img
                                        className={
                                            styles[
                                                'DistrictSlideCard__MobileImage'
                                            ]
                                        }
                                        sizes="100vw"
                                        srcSet={`${image.renditions.xlarge.src} 1646w,
                                 ${image.renditions.large.src} 1200w,
                                ${image.renditions.medium.src} 600w`}
                                        src={image.renditions.small.src}
                                        alt={`${image.alt}`}
                                    />
                                </figure>
                            )}
                        </div>
                        <div
                            className={
                                styles['DistrictSlideCard__TitleWrapper']
                            }>
                            <p className={styles['DistrictSlideCard__Label']}>
                                {label}
                            </p>
                            <h3 className={styles['DistrictSlideCard__Title']}>
                                {title}
                            </h3>
                        </div>
                    </div>
                    <p className={styles['DistrictSlideCard__Text']}>
                        {text.length > 130
                            ? `${text.substring(0, 150)}...`
                            : text}
                    </p>
                    <ul className={styles['DistrictSlideCard__List']}>
                        {tags.map((tag, i) => (
                            <li
                                key={i}
                                className={
                                    styles['DistrictSlideCard__ListItems']
                                }>
                                {tag.label}
                            </li>
                        ))}
                    </ul>
                    <div className={styles['DistrictSlideCard__LinkContainer']}>
                        <Button
                            className={styles['DistrictSlideCard__Link']}
                            href={link.href}
                            type="tertiary"
                            icon="arrow"
                            iconSize="large"
                            iconColor="pink"
                            buttonColor="pink"
                            text={link.text}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

DistrictSlideCard.propTypes = {};

export default DistrictSlideCard;
